import React from 'react';

const ProjectsSection = () => {
  const projects = [
    {
      category: 'Air Conditioning Installations',
      image: 'https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxodmFjfGVufDB8fHx8MTc3NTc4MDYzMHww&ixlib=rb-4.1.0&q=85',
    },
    {
      category: 'Refrigeration Systems',
      image: 'https://images.pexels.com/photos/7937299/pexels-photo-7937299.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    },
    {
      category: 'Plumbing Works',
      image: 'https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwbHVtYmluZ3xlbnwwfHx8fDE3NzU3ODA2Mzl8MA&ixlib=rb-4.1.0&q=85',
    },
    {
      category: 'Maintenance & Repairs',
      image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxtYWludGVuYW5jZXxlbnwwfHx8fDE3NzU3ODA2NDN8MA&ixlib=rb-4.1.0&q=85',
    },
  ];

  return (
    <section id="projects" className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Work
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Professional installations and maintenance across all our service areas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl h-80 cursor-pointer"
            >
              <img
                src={project.image}
                alt={project.category}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/50 to-transparent group-hover:from-amber-900/80 group-hover:via-gray-950/70 transition-all duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-2xl font-bold text-white group-hover:text-amber-400 transition-colors">
                  {project.category}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
